import React from 'react'

/**
 * Estado global de loading sin provider
 * Se puede usar desde cualquier componente sin configuración
 */

class GlobalLoadingManager {
  constructor() {
    this.isLoading = false
    this.loadingCount = 0
    this.listeners = new Set()
  }

  startLoading() {
    // console.log('startLoading')
    this.loadingCount += 1
    this.isLoading = true
    this.notifyListeners()
  }

  endLoading() {
    // console.log('endLoading')
    this.loadingCount = Math.max(0, this.loadingCount - 1)
    this.isLoading = this.loadingCount > 0
    this.notifyListeners()
  }

  setLoading(loading) {
    this.isLoading = loading
    this.loadingCount = loading ? 1 : 0
    this.notifyListeners()
  }

  subscribe(callback) {
    this.listeners.add(callback)
    return () => {
      this.listeners.delete(callback)
    }
  }

  notifyListeners() {
    this.listeners.forEach(callback => {
      callback({
        isLoading: this.isLoading,
        loadingCount: this.loadingCount
      })
    })
  }

  getState() {
    return {
      isLoading: this.isLoading,
      loadingCount: this.loadingCount
    }
  }
}

// Instancia global
const globalLoadingManager = new GlobalLoadingManager()

// Hook personalizado para usar el estado global
export const useGlobalLoading = () => {
  const [state, setState] = React.useState(globalLoadingManager.getState())
  
  React.useEffect(() => {
    const unsubscribe = globalLoadingManager.subscribe(setState)
    return unsubscribe
  }, [])
  
  return {
    isLoading: state.isLoading,
    loadingCount: state.loadingCount,
    startLoading: () => globalLoadingManager.startLoading(),
    endLoading: () => globalLoadingManager.endLoading(),
    setLoading: (loading) => globalLoadingManager.setLoading(loading)
  }
}

// Exportar las funciones para uso directo
export const startLoading = () => globalLoadingManager.startLoading()
export const endLoading = () => globalLoadingManager.endLoading()
export const setLoading = (loading) => globalLoadingManager.setLoading(loading)

export default globalLoadingManager
